export { SalonInfo } from './SalonInfo';
